import axiosApiInstance from "../app/axios";
import { PARKIT_API_BASE_URL } from "../app/utils";
import { getJwtToken } from "../app/common";

export const getWorkflowTasks = async (page, size) =>
  axiosApiInstance.get(`${PARKIT_API_BASE_URL}/parkit/v2/workflow/tasks`, {
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });

export const getListings = async (page, size, sort, sortBy, status, search, searchType, filter) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/listings?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}&status=${status}${search ? '&search=' + encodeURIComponent(search) + '&searchType=' + searchType : ''}${filter ? '&filter=' + filter : ''}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const getListingsWithRentingTerminating = async (page, size, sort, sortBy, status, search, searchType, filter) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/listings?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}&status=${status}&rentingTerminating=true${search ? '&search=' + encodeURIComponent(search) + '&searchType=' + searchType : ''}${filter ? '&filter=' + filter : ''}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const updateListing = async (id, data) =>
  axiosApiInstance.post(`${PARKIT_API_BASE_URL}/parkit/v2/listings/${id}/patch`, data, {
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });

export const getListingAgreement = async (id) =>
  axiosApiInstance.get(`${PARKIT_API_BASE_URL}/parkit/v2/listings/${id}/agreement/document`, {
    responseType: "blob",
  });

export const addListing = async (data) =>
  axiosApiInstance.post(`${PARKIT_API_BASE_URL}/parkit/v2/listings`, data, {
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });

export const uploadListingAccessCard = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosApiInstance.post(
    `${PARKIT_API_BASE_URL}/parkit/v2/listings/${id}/access-card`,
    formData,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );
};

export const deleteListingAccessCard = async (id) =>
  axiosApiInstance.delete(
    `${PARKIT_API_BASE_URL}/parkit/v2/listings/${id}/access-card`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );
